import { render, staticRenderFns } from "./BidDashboardWaitingOpen.vue?vue&type=template&id=59e1483e&scoped=true"
import script from "./BidDashboardWaitingOpen.vue?vue&type=script&lang=js"
export * from "./BidDashboardWaitingOpen.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardWaitingOpen.vue?vue&type=style&index=0&id=59e1483e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1483e",
  null
  
)

export default component.exports